import { gql } from 'graphql-request'

import { AccessInstructionQueries } from './accessInstructions.queries'
import { AttachmentQueries } from './attachments.queries'
import { HomeIssueQueries } from './homeIssues.queries'

export namespace HomeQualityCheckQueries {
  export const QUERY_KEYS = {
    getHomeQualityChecks: 'getHomeQualityChecks',
    getHomeQualityCheck: 'getHomeQualityCheck',
  }

  export function getHomeQualityChecks() {
    return gql`
      query getHomeQualityChecks($filter: HomeQualityCheckFilter = { limit: 50 }) {
        homeQualityChecks(filter: $filter) {
          id
          home {
            id
            searchDocument
          }
          notes
          precedingReservationId
          precedingReservationMoveOutDate
          status
          upcomingReservationId
          upcomingReservationMoveInDate
        }
      }
    `
  }

  export function getHomeQualityCheck() {
    return gql`
      query HomeQualityCheck($id: Int!) {
        homeQualityCheck(id: $id) {
          id
          createdAt
          notes
          status
          hostCleaningRating
          homeIssues {
            ...HomeIssueSummary
          }
          home {
            accessInstructions {
              ...AccessInstructionDetails
            }
            keys {
              id
              accessType
              ownership
              keyType
            }
          }
          precedingReservation {
            id
            hostDoorAccessCode
            memberDoorAccessCode
            lockboxCode
            lockboxBackupCode
            intercomCode
            includeDamageWaiverFee
          }
          upcomingReservation {
            id
            hostDoorAccessCode
            memberDoorAccessCode
            lockboxCode
            lockboxBackupCode
            intercomCode
          }
          turnoverCleaningJob {
            id
            host {
              fullName
            }
            scheduleDate
            jobTemplate {
              name
            }
          }
          inspections {
            homeLocation
            status
            total
            totalCompleted
          }
          inspectionTasks {
            id
            homeQualityCheckInspectionTaskTemplate {
              homeLocation
              homeQualityCheckInspectionType
              taskOrder
              homeInventoryItem
              prompt
              promptHomeIssue
              inspectionTaskType
            }
            homeIssue {
              notes
              resolvedAt
            }
            response
            completedAt
            completedBy {
              fullName
            }
            homeIssueId
          }
        }
      }
      ${HomeIssueQueries.HOME_ISSUE_SUMMARY}
      ${AccessInstructionQueries.ACCESS_INSTRUCTIONS_DETAILS}
      ${AttachmentQueries.ATTACHMENT_DETAILS}
    `
  }

  export const HOME_QUALITY_CHECK_SUMMARY = gql`
    fragment HomeQualityCheckSummary on HomeQualityCheck {
      id
      home {
        id
      }
      notes
      precedingReservationId
      precedingReservationMoveOutDate
      status
      upcomingReservationId
      upcomingReservationMoveInDate
      attachments {
        ...AttachmentDetails
      }
    }
  `
}
